module.exports = __webpack_public_path__ + "img/OBCINA HRPELJE-KOZINA.0fe254e6.png";